import { frame1_icon, frame2_icon, frame3_icon, frame4_icon } from "./images";

export const REACT_APP_STRIPE_PUBLISHABLE_KEY =
  "pk_test_TYooMQauvdEDq54NiTphI7jx";
export const REACT_APP_STRIPE_SECRET_KEY = "sk_test_4eC39HqLyjWDarjtT1zdp7dc";

export const DropDownValues = [
  {
    title: "All",
    id: "all",
  },
  {
    title: "Scholarship H & A",
    id: "scholarship_honors_awards",
  },
  {
    title: "Leadership H & A",
    id: "leadership_honors_awards",
  },
  {
    title: "Citizenship H & A",
    id: "citizenship_honors_awards",
  },
  {
    title: "Sportsmanship H & A",
    id: "sportsmanship_honors_awards",
  },
  {
    title: "Scholarship R & A",
    id: "scholarship_roles_activites",
  },
  {
    title: "Leadership R & A",
    id: "leadership_roles_activites",
  },
  {
    title: "Citizenship R & A",
    id: "citizenship_roles_activites",
  },
  {
    title: "Sportsmanship R & A",
    id: "sportsmanship_roles_activites",
  },
];
export const honors_awards_dropdown = [
  {
    title: "All",
    id: "all",
  },
  {
    title: "Scholarship H & A",
    id: "scholarship_honors_awards",
  },
  {
    title: "Leadership H & A",
    id: "leadership_honors_awards",
  },
  {
    title: "Citizenship H & A",
    id: "citizenship_honors_awards",
  },
  {
    title: "Sportsmanship H & A",
    id: "sportsmanship_honors_awards",
  },
];
export const roles_activites_dropdown = [
  {
    title: "All",
    id: "all",
  },
  {
    title: "Scholarship R & A",
    id: "scholarship_roles_activites",
  },
  {
    title: "Leadership R & A",
    id: "leadership_roles_activites",
  },
  {
    title: "Citizenship R & A",
    id: "citizenship_roles_activites",
  },
  {
    title: "Sportsmanship R & A",
    id: "sportsmanship_roles_activites",
  },
];
export const SubDropDown = [
  {
    title: "Roles and Activites",
    id: "roles_activites",
  },
  {
    title: "Honors and Awards",
    id: "honors_awards",
  },
];
export const PieChartDropdown = [
  {
    title: "Year Started",
    id: "year_started",
  },
  {
    title: "Type of Schools",
    id: "types_of_school",
  },
];

export const maleSport = [
  {
    title: "Football",
    id: "football",
  },
  {
    title: "Basketball",
    id: "basketball",
  },
  {
    title: "Baseball /Softball",
    id: "baseball",
  },
  {
    title: "Soccer",
    id: "soccer",
  },
  {
    title: "Lacrosse",
    id: "lacrosse",
  },
  {
    title: "Track and Field",
    id: "track_and_field",
  },
  {
    title: "Wrestling",
    id: "wrestling",
  },
  {
    title: "Cross Country",
    id: "cross_country",
  },
  {
    title: "Tennis",
    id: "tennis",
  },
  {
    title: "Golf",
    id: "golf",
  },
  {
    title: "Swimming",
    id: "swimming",
  },
];

export const femaleSports = [
  {
    title: "Basketball",
    id: "basketball",
  },
  {
    title: "Volleyball",
    id: "volleyball",
  },
  {
    title: "Soccer",
    id: "soccer",
  },
  {
    title: "Field Hockey",
    id: "field_hockey",
  },
  {
    title: "Softball",
    id: "softball",
  },
  {
    title: "Track and Field",
    id: "track_and_field",
  },
  {
    title: "Tennis",
    id: "tennis",
  },
  {
    title: "Golf",
    id: "golf",
  },
  {
    title: "Swimming",
    id: "swimming",
  },
];
export const participationLevel = [
  {
    title: "Junior Varsity",
    id: "Junior Varsity",
  },
  {
    title: "Varsity",
    id: "Varsity",
  },
  {
    title: "Club Level",
    id: "Club Level",
  },
  {
    title: "Lettered",
    id: "Lettered",
  },
  {
    title: "Team Captain/Co-Captain",
    id: "Team Captain/Co-Captain",
  },
  {
    title: "Most Valuable Player",
    id: "Most Valuable Player",
  },
  {
    title: "All-District",
    id: "All-District",
  },
  {
    title: "All-Conference",
    id: "All-Conference",
  },
  {
    title: "All State",
    id: "All State",
  },
  {
    title: "All American",
    id: "All American",
  },
];

export const ScndStepList = [
  {
    title: "Noteable",
    id: "community",
  },
  {
    title: "Emerging",
    id: "somewhat_competitive",
  },
  {
    title: "Moderate",
    id: "competitive",
  },
  {
    title: "High",
    id: "most_competitive",
  },
];
export const universityDropDownList = [
  {
    title: "All",
    id: "all",
  },
  {
    title: "Noteable",
    id: "community",
  },
  {
    title: "Emerging",
    id: "somewhat_competitive",
  },
  {
    title: "Moderate",
    id: "competitive",
  },
  {
    title: "High",
    id: "most_competitive",
  },
];
export const universityCreateType = [
  {
    title: "Noteable",
    id: "community",
  },
  {
    title: "Emerging",
    id: "somewhat_competitive",
  },
  {
    title: "Moderate",
    id: "competitive",
  },
  {
    title: "High",
    id: "most_competitive",
  },
];
export const FirstStepList = [
  {
    title: "Freshman",
    id: "freshman",
  },
  {
    title: "Softmore",
    id: "sophomore",
  },
  {
    title: "Junior",
    id: "junior",
  },
  {
    title: "Senior",
    id: "senior",
  },
];

export const scholarshipDropdown = [
  {
    title: "Not Submit",
    id: "none",
  },
  {
    title: "Accepted",
    id: "accepted",
  },
  {
    title: "Rejected",
    id: "rejected",
  },
  {
    title: "Applied",
    id: "applied",
  },
];

export const dashboardDropdown = [
  {
    title: "Scholarship",
    id: "scholarship",
  },
  {
    title: "University",
    id: "university",
  },
];

export function convertObjectToString(obj) {
  // Extract values from the object
  let grades = obj.grades;
  let minGrade, maxGrade;

  if (grades && typeof grades === "string" && grades.includes(",")) {
    const gradesArray = grades
      .split(",")
      .map(Number)
      .sort((a, b) => a - b);
    minGrade = gradesArray[0];
    maxGrade = gradesArray[gradesArray.length - 1];
    grades = `${minGrade}th - ${maxGrade}th`;
  } else if (grades && typeof grades === "string") {
    minGrade = maxGrade = parseInt(grades, 10); // Convert to number
    grades = `${minGrade}th`;
  } else {
    // Handle case when grades is null, undefined, or not a string
    grades = "";
  }

  const weeks = obj.weeks;
  const hours = obj.hours;

  // Construct the string
  // const str =  `${grades}, ${weeks} Weeks / Year, ${hours} Hours / Week`;

  let str = "";

  // Add grades if available
  if (grades) {
    str += `${grades}`;
  }

  // Add weeks if available
  if (weeks) {
    if (str !== "") {
      // Add semicolon if previous part is added
      str += ", ";
    }
    str += `${weeks} Weeks / Year`;
  }

  // Add hours if available
  if (hours) {
    if (str !== "") {
      // Add semicolon if previous part is added
      str += ", ";
    }
    str += `${hours} Hours / Week`;
  }
  return str;
}

export function divideIntoGroups(maxNumber) {
  const groups = [
    {
      id: "empty",
      range: "Empty",
    },
  ];
  let start = 1;
  let end = 5;
  let id = 1; // Initialize the ID counter
  while (end <= maxNumber) {
    groups.push({ id: String(id), range: `${start}-${end}` });
    start += 5;
    end += 5;
    id += 5; // Increment the ID counter
  }
  // Add the remaining numbers if any
  if (start <= maxNumber) {
    groups.push({ id: String(id), range: `${start}-${maxNumber}` });
  } else if (maxNumber === 50) {
    // Add an additional group for numbers 51-52
    groups.push({ id: String(id), range: "51-52" });
  }
  return groups;
}

export const Dashboard_AR = [
  {
    title: "Scholarship Activities and Roles",
    id: "sc_roles",
  },
  {
    title: "Leadership Activities and Roles",
    id: "ld_roles",
  },
  {
    title: "Citizenship Activities and Roles",
    id: "ct_roles",
  },
  {
    title: "Sportsmanship Activities and Roles",
    id: "sp_roles",
  },
];
export const Dashboard_HA = [
  {
    title: "Scholarship Honors and Awards",
    id: "sc_honors",
  },
  {
    title: "Leadership Honors and Awards",
    id: "ld_honors",
  },
  {
    title: "Citizenship Honors and Awards",
    id: "ct_roles",
  },
  {
    title: "Sportsmanship Honors and Awards",
    id: "sp_honors",
  },
];

export const dashboard = [
  {
    title: "Scholarship Activities and Roles",
    id: "sc_roles",
  },
  {
    title: "Leadership Activities and Roles",
    id: "ld_roles",
  },
  {
    title: "Citizenship Activities and Roles",
    id: "ct_roles",
  },
  {
    title: "Sportsmanship Activities and Roles",
    id: "sp_roles",
  },
  {
    title: "Scholarship Honors and Awards",
    id: "sc_honors",
  },
  {
    title: "Leadership Honors and Awards",
    id: "ld_honors",
  },
  {
    title: "Citizenship Honors and Awards",
    id: "ct_honors",
  },
  {
    title: "Sportsmanship Honors and Awards",
    id: "sp_honors",
  },
];

export const countValuesEqualToOrLessThanScore = (array, score) => {
  let count = 0;
  for (let i = 0; i < array.length; i++) {
    if (array[i] <= score) {
      count++;
    }
  }
  return count;
};

export function scrollAdjust() {
  // setTimeout(() => {
  //   let heightOfSystem = window.innerHeight;
  //   var ele = document.getElementById('set_my_scroll_window').offsetHeight;
  //   if (heightOfSystem > 700) {
  //     ele = ele - 50;
  //     ele = ele + 'px';
  //   }
  //   if (heightOfSystem < 700 && heightOfSystem < 650) {
  //     ele = ele - 200;
  //     ele = ele + 'px';
  //   }
  //   if (heightOfSystem < 700 && heightOfSystem > 650) {
  //     ele = ele - 130;
  //     ele = ele + 'px';
  //   }
  //   document.getElementById('set_my_scroll_window').style.height = ele;
  // }, 2000);
}

export function roundAndFormatNumberString(inputString) {
  // Check if the input string starts with zero
  if (inputString.startsWith("0")) {
    return "0";
  }

  // Check if the input string contains a decimal point
  if (inputString.includes(".")) {
    // Convert the input string to a number and round it
    const roundedNumber = Math.round(parseFloat(inputString));

    // Format the rounded number to display with a maximum of 2 decimal places
    const formattedNumber = roundedNumber.toFixed(2);

    return formattedNumber;
  } else {
    // If no decimal point exists, just round the number to the nearest integer
    const roundedNumber = Math.round(parseInt(inputString));
    return roundedNumber.toString(); // Convert back to string
  }
}

export const stringToInt = (value) => {
  if (typeof value === "string") {
    const parsed = parseInt(value, 10); // 10 is the radix parameter for decimal base
    if (!isNaN(parsed)) {
      return parsed;
    } else {
      return value; // Return the original value if it can't be converted
    }
  } else {
    return value; // Return the original value if it's not a string
  }
};

export const stripe_promise = () => {
  const { host } = window.location;

  var stripe_key =
    "pk_live_51NlPfvL5MmXwVUFI0YtiJkEidkASIszXkcBtECBTMyIYB5uVPzbzOzb3HhMO82HdJeN2dvr8qh2GY10YjhlkpbTy006DZOvKRo";

  if (host.includes("localhost") || host.includes("dev")) {
    stripe_key =
      "pk_test_51NlPfvL5MmXwVUFIWtS5YXDtp0i0DgF5vKxKzNK0I3PaczkJgtDkvZMRJQp37D9PQiUhhZSdI3fHBzMdxyYvE3Ox00JgkdDs4l";
  } else {
    stripe_key =
      "pk_live_51NlPfvL5MmXwVUFI0YtiJkEidkASIszXkcBtECBTMyIYB5uVPzbzOzb3HhMO82HdJeN2dvr8qh2GY10YjhlkpbTy006DZOvKRo";
  }

  return stripe_key;
};

export const formatTestScores = (psatData = [], satData = []) => {
  return {
    psat: psatData.map((item) => ({
      math: item.math,
      reading_writing: item.reading,
      total: item.total,
      test_date: item.date,
    })),
    sat: satData.map((item) => ({
      math: item.math,
      reading_writing: item.reading,
      total: item.total,
      test_date: item.date,
    })),
  };
};

export const coverttestScores = (data) => {
  const formattedScores = [];

  data &&
    data.length > 0 &&
    data.forEach((item) => {
      formattedScores.push({
        math: item.math,
        reading: item.reading_writing,
        total: item.total,
        date: item.test_date,
        type: item.type,
      });
    });

  return formattedScores;
};

export const fixTitle = (title, number) => {
  if (title && !number) {
    if (title.length >= 10) {
      return `${title.slice(0, 8)}...`;
    } else {
      return title;
    }
  } else if (title && number) {
    if (title.length >= 20) {
      return `${title.slice(0, 18)}...`;
    } else {
      return title;
    }
  }
};

export const fixNews = (title) => {
  if (title) {
    if (title.length > 15) {
      return `${title.slice(0, 18)}...`;
    } else {
      return title;
    }
  }
};

export const getPlainText = (html) => {
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = html;
  return tempDiv.innerText || tempDiv.textContent;
};

export const statusChange = (newStatus, questions, questionId) => {
  const updateScholarship = [...questions];

  const existingData = updateScholarship.find((item) => item.id === questionId);

  if (existingData) {
    // alert('')
    existingData.status = newStatus;
  }

  return updateScholarship;
};

export const cardlisting = [
  { uperName: "Prompt Against", lowerName: "Your Data", img: frame4_icon },
  { uperName: "Complete College", lowerName: "Application", img: frame1_icon },
  { uperName: "Preview Resume", img: frame2_icon },
  { uperName: "Write Essay", img: frame3_icon },
];

export const styleComponent = { height: "calc(100dvh - 0px)" };

export const fixTooltip = (title) => {
  if (title) {
    if (title.length > 65) {
      return `${title.slice(0, 65)}....`;
    } else {
      return title;
    }
  }
};

export function truncateText(text, maxWidth, maxLines, font = "16px Arial") {
  // Create a canvas element to measure text width
  const canvas = document.createElement("canvas");
  const context = canvas.getContext("2d");
  context.font = font;

  // Helper function to calculate the width of the text
  const getTextWidth = (txt) => context.measureText(txt).width;

  let truncatedText = "";
  let lineCount = 0;
  let currentLine = "";

  // Iterate over each word
  for (let word of text.split(" ")) {
    let newLine = currentLine + (currentLine.length > 0 ? " " : "") + word;
    let lineWidth = getTextWidth(newLine);

    // Check if the line exceeds the maximum width
    if (lineWidth > maxWidth) {
      lineCount++;
      // Append the current line to the truncated text
      truncatedText += currentLine + "\n";

      // If we have reached the maxLines limit, add ellipsis
      if (lineCount >= maxLines) {
        truncatedText = truncatedText.trim() + "...";
        break;
      }
      // Start a new line
      currentLine = word;
    } else {
      currentLine = newLine;
    }
  }

  // Add the last line if it's within the allowed lines
  if (lineCount < maxLines) {
    truncatedText += currentLine;
  }

  return truncatedText.trim();
}

// Example Usage:
const originalText =
  "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec venenatis quam non leo consectetur, at venenatis magna.";
const maxWidth = 450; // Maximum width for each line
const maxLines = 2; // Maximum number of lines

const truncatedText = truncateText(originalText, maxWidth, maxLines);
console.log(truncatedText);

export const getModalData = (newData, answers, questionId) => {
  const updatedData = [...answers];

  const existingDataIndex = updatedData.findIndex(
    (item) => item.id === questionId
  );

  if (existingDataIndex !== -1) {
    updatedData[existingDataIndex] = {
      ...updatedData[existingDataIndex],
      activityName: newData.answer,
      weeksPerYear: newData.weeks,
      hoursPerWeek: newData.hours,
      gradesInvolved: newData.grades,
      id: newData.id,
      participationLevelId: newData.accomplishment
        ? newData.accomplishment
        : "",
      dropdownId: newData.sport ? newData.sport : "",
    };
  } else {
    updatedData.push({
      activityName: newData.answer,
      weeksPerYear: newData.weeks,
      hoursPerWeek: newData.hours,
      gradesInvolved: newData.grades,
      id: newData.id,
      participationLevelId: newData.accomplishment
        ? newData.accomplishment
        : "",
      dropdownId: newData.sport ? newData.sport : "",
    });
  }

  return updatedData;
};

// export const convertDateFormat =(dateStr)=> {
//   const months = {
//     Jan: '01', Feb: '02', Mar: '03', Apr: '04', May: '05', Jun: '06',
//     Jul: '07', Aug: '08', Sep: '09', Oct: '10', Nov: '11', Dec: '12'
//   };

//   const [monthStr, day, year] = dateStr.split(' ');
//   const month = months[monthStr];
//   const formattedDay = day.replace(',', '').padStart(2, '0');

//   return `${year}-${month}-${formattedDay}`;
// }

export const fixScholarshipTitle = (title) => {
  if (!title) return "";

  const isResponsive = window.innerWidth <= 480;

  // If the screen width is >= 480, apply word-breaking after 4 characters (with CSS)
  if (isResponsive) {
    if (title.length > 6) {
      return `${title.slice(0, 6)}...`; // Return 4 characters if it exceeds
    } else {
      return `${title}`; // Return full title if it's <= 4 characters
    }
  }

  // For non-responsive (width < 480), display 17 characters without word breaking
  if (title.length > 17) {
    return `${title.slice(0, 17)}...`; // Return first 17 characters
  }

  return title; // Return full title if it's <= 17 characters
};
export const fixSlice = (title) => {
  if (title) {
    if (title.length > 300) {
      return `${title.slice(0, 300)}...`;
    } else {
      return `${title}`;
    }
  }
};

export const fixLink = (title) => {
  if (title) {
    if (title.length > 80) {
      return `${title.slice(0, 80)}...`;
    } else {
      return title;
    }
  }
};

export const updateQuestions = (newData, answers, type) => {
  const updatedData = [...answers];

  const existingDataIndex = updatedData.findIndex(
    (item) => item.id === newData.id
  );

  if (existingDataIndex !== -1) {
    if (type === "universities") {
      updatedData[existingDataIndex] = {
        ...updatedData[existingDataIndex],
        title: newData.title ? newData.title : "",
        description: newData.description ? newData.description : "",
      };
    } else if (type === "news") {
      updatedData[existingDataIndex] = {
        ...updatedData[existingDataIndex],
        title: newData.title ? newData.title : "",
        description: newData.description ? newData.description : "",
        link: newData.link ? newData.link : "",
      };
    } else if (type === "scholarship") {
      updatedData[existingDataIndex] = {
        ...updatedData[existingDataIndex],
        award_worth: newData?.award_worth,
        category: newData?.category,
        deadline: newData?.deadline,
        description: newData?.description,
        grade: newData?.grade,
        grade_level: newData?.grade_level,
        link: newData?.link,
        offered_by: newData?.offered_by,
        title: newData?.title,
      };
    }
  }
  return updatedData;
};

export const savedChange = (questions, newData, isSaved) => {
  const updateSavedQuestion = [...questions];
  const existingData = updateSavedQuestion.find(
    (item) => item.id === newData.id
  );

  if (existingData) {
    existingData.saved = isSaved;
  }
  return updateSavedQuestion;
};

export const formatString = (str) => {
  if (!str) return "";

  // Case 1: Check if it starts with $ and has a range with '-'
  if (str.startsWith("$") && str.includes("-")) {
    const rangeParts = str.split("-");
    if (rangeParts.length === 2) {
      const formattedRange = rangeParts.map((part) =>
        formatPriceToK(part.trim())
      );
      return `${formattedRange[0]} - ${formattedRange[1]}`;
    }
  }

  // Case 2: If it starts with $ but has no '-'
  if (str.startsWith("$")) {
    return formatPriceToK(str);
  }

  // Case 3: If it doesn't contain '$', return with a limit of 10 characters
  if (!str.includes("$")) {
    return str.length > 4 ? `${str.slice(0, 4)}...` : str;
  }

  return str;
};

// Helper function to convert price to K notation
export const formatPriceToK = (price) => {
  const numericPrice = Number(price.replace(/[^0-9.-]+/g, "")); // Remove non-numeric characters like "$" and ","

  if (isNaN(numericPrice)) {
    return "Invalid price"; // Handle invalid inputs
  }

  if (numericPrice >= 1000) {
    return `$${numericPrice / 1000}K`; // Format in 'K'
  }

  return `$${numericPrice}`; // Return the original value if it's less than 1000
};

export const formatDeadline = (date) => {
  let deadline = ""; // Initialize deadline as an empty string

  // Check if the input is in the format 'Mar-25' (month abbreviation and year)
  const monthYearRegex = /^[a-zA-Z]{3}-\d{2}$/;

  if (typeof date === "string" && monthYearRegex.test(date)) {
    // Handle 'Mar-25' format
    const [monthStr, yearStr] = date.split("-");

    // Convert the month string to a corresponding month number (0-indexed for JavaScript Date object)
    const monthIndex = new Date(`${monthStr} 1, 2023`).getMonth(); // Using a dummy year to get month

    const year = parseInt(`20${yearStr}`); // Interpret the year as 20XX (e.g., '25' -> '2025')

    // Set the day as 1
    date = new Date(year, monthIndex, 1);
  }

  // Check if the date is in the format 'YYYY-MM-DD'
  if (typeof date === "string" && /^\d{4}-\d{2}-\d{2}$/.test(date)) {
    date = new Date(date);
  }

  // Check if input is a valid Date object
  if (!(date instanceof Date) || isNaN(date.getTime())) {
    return ""; // Return an empty string if the date is invalid
  }

  // Format the date as 'YYYY-MM-DD'
  const year = date.getFullYear();
  const month = ("0" + (date.getMonth() + 1)).slice(-2); // Ensure month is two digits
  const day = ("0" + date.getDate()).slice(-2); // Ensure day is two digits

  return `${year}-${month}-${day}`;
};

export const formatAwardWorth = (value) => {
  // If the value contains a range, extract the maximum value
  if (value.includes("-")) {
    // Split the value by '-'
    const parts = value.split("-");

    // Get the minimum and maximum values, removing non-numeric characters
    const minValue = Number(parts[0].replace(/[^0-9.]/g, "").trim()); // First part is the minimum value
    const maxValue = Number(parts[1].replace(/[^0-9.]/g, "").trim()); // Second part is the maximum value

    console.log(maxValue, "maxValuemaxValuemaxValue");
    console.log(minValue, "minValueminValueminValue");
    // Calculate the difference
    const difference = maxValue - minValue;

    console.log(difference, "differencedifference");
    // Return the difference
    return maxValue;
  }

  // If it's not a range, just remove non-numeric characters
  return value.replace(/[^0-9.]/g, ""); // Remove all non-numeric characters from the single value
};

export function checkDollar(value) {
  // Check if the value contains a dollar sign at the beginning
  if (!value.startsWith("$")) {
    // If not, prepend a dollar sign
    return `$${value}`;
  }
  // If it already contains a dollar sign, return the original value
  return value;
}

export const checkDevice = () => {
  // const userAgent = navigator.userAgent;
  // if (userAgent.indexOf("Firefox") > -1) {
  // }
  // const userAgent = navigator.userAgent;
  // if (userAgent.indexOf("Firefox") > -1) {
  //   browserName = "Firefox";
  //   browserVersion = userAgent.match(/Firefox\/([0-9.]+)/)[1];
  // }
  // if (navigator.userAgentData) {
  //   navigator.userAgentData.getHighEntropyValues(["platform"]).then((ua) => {
  //     if (ua.platform === "Windows") {
  //       console.log("The user is running Windows");
  //     } else if (ua.platform === "macOS") {
  //       let demoElement = document.querySelector('input[type="date"]');
  //       demoElement.style.display = "flex";
  //       demoElement.style.textAlign = "-webkit-center";
  //       console.log("The user is running macOS");
  //     }
  //   });
  // } else {
  //   // Fallback to userAgent if userAgentData is not available
  //   const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  //   if (userAgent.indexOf("Win") !== -1) {
  //     let demoElement = document.querySelector('input[type="date"]');
  //     demoElement.style.display = "flex";
  //     demoElement.style.textAlign = "-webkit-center";
  //   } else if (userAgent.indexOf("Mac") !== -1) {
  //     let demoElement = document.querySelector('input[type="date"]');
  //     demoElement.style.display = "flex";
  //     demoElement.style.textAlign = "-webkit-center";
  //   }
  // }
};

export const getDaysUntilDeadline = (deadline) => {
  // Get the current date
  const today = new Date();

  // Parse the deadline date (ensure the format is YYYY-MM-DD)
  const deadlineDate = new Date(deadline);

  // Calculate the difference in time (in milliseconds)
  const timeDifference = deadlineDate - today;

  // Convert the time difference to days (ignoring time portion)
  const daysDifference = Math.floor(timeDifference / (1000 * 60 * 60 * 24));

  // Return the number of days left
  return daysDifference;
};

export const checkDeviceAndBrowser = () => {
  const userAgent = navigator.userAgent.toLowerCase();

  // Check if the device is iPhone
  const isIOS = /iphone|ipad|ipod/.test(userAgent) && !window.MSStream;

  // Check if the browser is Safari
  const isSafari =
    userAgent.includes("safari") && !userAgent.includes("chrome");

  // If all conditions are true, return true, otherwise return false
  if (isIOS && isSafari) {
    return true;
  }

  return false;
};

export function truncateTitle(title = "", wordLimit = 4, charLimit = 10) {
  // Split the title into words
  const words = title.split(" ");

  // Check if the word limit is exceeded
  if (words.length > wordLimit) {
    return words.slice(0, wordLimit).join(" ") + "...";
  }

  // Check if the character limit is exceeded for a single long word or short sentence
  if (title.length > charLimit) {
    return title.slice(0, charLimit) + "...";
  }

  return title;
}

export const capitalizeFirst = (str) => {
  if (str && str.length > 0) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }
  return str;
};

export const getMonthName = (monthNumber) => {
  return new Date(2000, monthNumber - 1).toLocaleString("default", {
    month: "short",
  }); // e.g., "Feb"
};

export const brandLogos = {
  visa: "https://img.icons8.com/color/48/visa.png",
  mastercard: "https://img.icons8.com/color/48/mastercard-logo.png",
  amex: "https://img.icons8.com/color/48/amex.png",
  discover: "https://img.icons8.com/color/48/discover.png",
  diners: "https://img.icons8.com/color/48/diners-club.png",
  jcb: "https://img.icons8.com/color/48/jcb.png",
  unionpay: "https://img.icons8.com/color/48/unionpay.png",
  // fallback if brand not found
  default: "https://img.icons8.com/ios-filled/50/bank-card-back-side.png",
};

export const getPlanMessage = (currentPlan, selectedPlan) => {
  if (!currentPlan || !selectedPlan) return "";

  const isSamePlan = currentPlan.price === selectedPlan.price;
  const isDowngrade = selectedPlan.is_downgrade;
  const isUpgrade = !isDowngrade;

  const rawAmount = selectedPlan.prorated_amount ?? selectedPlan.price;
  const amount = Number(rawAmount || 0);
  const isFree = isNaN(amount) || amount === 0;

  let priceText = "";
  if (!isFree) {
    priceText = `$${amount}`;
  }

  const planName = selectedPlan.name;

  if (isSamePlan) {
    return `You're already on the ${planName} plan.\nAre you sure you want to keep this plan?`;
  }

  if (isDowngrade) {
    return isFree
      ? `Are you sure you want to downgrade to ${planName}?\nIt's a free plan.`
      : `Are you sure you want to downgrade to ${planName}?\nYou'll be charged ${priceText} starting next billing date.`;
  }

  if (isUpgrade && selectedPlan.requires_instant_payment) {
    return `Are you sure you want to upgrade to ${planName}?\nWe’ll charge you ${priceText} now, and your plan will start immediately.`;
  }

  if (isUpgrade && !selectedPlan.requires_instant_payment) {
    return `Are you sure you want to upgrade to ${planName}?\nYou’ll be charged ${priceText} from your next billing cycle.`;
  }

  return `Are you sure you want to switch to the ${planName} plan${
    priceText ? `?\nThe price will be ${priceText}.` : "?"
  }`;
};